import { render, staticRenderFns } from "./fccOpcaoTabela.vue?vue&type=template&id=be0be234"
import script from "./fccOpcaoTabela.vue?vue&type=script&lang=js"
export * from "./fccOpcaoTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports